import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClose() {
  return <section className="py-16 px-4 md:px-8 bg-gradient-to-b from-white to-orange-50" data-id="element-80">
      <div className="max-w-4xl mx-auto text-center" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-82">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1A1A1A] mb-8 leading-tight" data-id="element-83">
            El tiempo no espera. Su historia merece quedar guardada.
          </h2>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-84">
            Dentro de 10 años, cuando tus hijos pregunten cómo era la vida de su
            abuela, vas a poder abrir este libro, mostrarles su letra y decir:
          </p>
          <p className="text-xl md:text-2xl font-semibold text-[#1A1A1A] mt-6 italic" data-id="element-85">
            "Esto es lo que vivió. Y esto es lo que quería que supieras."
          </p>
        </motion.div>
      </div>
    </section>;
}